import { ScoreNumber } from "../components/ScoreNumber";
import { characters } from "../data/characters";
import scss from "./ScoreItem.module.scss";

export const ScoreItem = ({ characterId, achievement, index }) => {
  return (
    <div className={scss.scoreItem}>
      <div className={scss.imgWrapper}>
        <img
          alt={characters[characterId].name}
          src={characters[characterId].scoreIcon}
        />
      </div>
      <label>
        <span className={achievement.value < 0 ? scss.textRed : scss.textBlue}>
          {achievement.category}
        </span>
        <br />
        {achievement.name}
      </label>
      <ScoreNumber number={achievement.value} />
    </div>
  );
};
